<template>
    <div class="mPage">
        <!-- 播放视频 -->
        <div id="videoPlayWrapper" v-show="isShowVideo">
            <div class="videoContent">
                <div class="closeVideo" @click="closeVideo()">×</div>
                <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls></video></div>
            </div>
        
        
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'm_mainpage',
    data: function () {
        return {
            currentPage: 1,
            numPages: 1,
            isShowVideo: false,
            currentVideoUrl:''
        }
    },
    
    methods: {
        tolive (url) {
            window.open(url)   
        },
        toHref (href) {
            window.open(href)  
        },
        closeVideo () {
            this.isShowVideo = false
            var myvideo = document.getElementById('liveVideo');
            if (!myvideo.paused) {
                myvideo.pause();
            }
        }

    },
    
    mounted () {

    },
    created () {
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mPage {
    width: 100%;
    text-align: center;
    position: relative;
    .topBg {
        width: 100%;
    }
    .banner {
        width: 100%;
        padding: 0.1rem;
        box-sizing: border-box;

    }
    #videoPlayWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
        }
        #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
        }
        .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        }
        .videoContainer {
        text-align: center;
        width: 100%;
        }
        .videoContainer video {
        width: 100%;
    }
}
</style>
